export default "__VITE_ASSET__CUXLpI28__"